module.exports = __webpack_public_path__ + "img/another-bubble.7c6b883.gif";